import React, { useCallback, useEffect, useMemo } from 'react'

import { Dialog } from '@/components'
import { Box, Button, Typography } from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import { markSessionMessageAsReaded } from '@/store/modules/auth/reducer'
import { SESSION_MESSAGES_IDS } from '@/store/modules/auth/sessionMessages'

export function OpenPalletModal() {
  const dispatch = useDispatch()

  const currentOrders = useSelector(
    (state) => state.users.ordersForCollect.orders
  )

  const sessionMessages = useSelector((state) => state.auth.sessionMessages)

  const [dialogOpen, setDialogOpen] = React.useState(false)

  const hasOpenPallet = useMemo(() => {
    return currentOrders
      ?.flatMap((orders) => orders.itens)
      .some((orderItem) => {
        return orderItem.tipo === 'P' && orderItem.qtd_caixas_disp > 0
      })
  }, [currentOrders])

  const showOpenPalletAlert = useCallback(() => {
    const message = sessionMessages.find(
      (message) => message.id === SESSION_MESSAGES_IDS.openPalletAlert
    )

    const isUnreaded = !message?.readed

    // Show on first access
    setDialogOpen(hasOpenPallet && isUnreaded)
  }, [hasOpenPallet, sessionMessages])

  function handleClose() {
    dispatch(
      markSessionMessageAsReaded({ id: SESSION_MESSAGES_IDS.openPalletAlert })
    )

    setDialogOpen(false)
  }

  useEffect(() => {
    showOpenPalletAlert()
  }, [showOpenPalletAlert])

  return (
    <Dialog
      title="Atenção"
      open={dialogOpen}
      actions={
        <>
          <Button variant="outlined" onClick={handleClose}>
            Estou ciente
          </Button>
        </>
      }
    >
      <Box py={2}>
        <Typography
          component="p"
          variant="body1"
          color="textSecondary"
          style={{ lineHeight: '1.6', textAlign: 'justify' }}
          gutterBottom
        >
          Sr Transportador, você possui pedidos em carteira com itens
          fracionados, onde o agendamento tem que ser feito de forma antecipada,
          no dia útil anterior a data da coleta até as 16 horas.
        </Typography>

        <Typography
          component="p"
          variant="body1"
          color="error"
          style={{
            lineHeight: '1.6',
            fontWeight: 'bold',
          }}
        >
          NÃO SEPARAMOS FRACIONADOS SEM PRÉ AGENDAMENTO
        </Typography>
      </Box>
    </Dialog>
  )
}
